import { render, staticRenderFns } from "./RecoveredForm.vue?vue&type=template&id=0e34ad4e"
import script from "./RecoveredForm.vue?vue&type=script&lang=js"
export * from "./RecoveredForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports